import { TsDOM as q} from '@/scripts/core/TsDOM'
import { PaintPopup } from '@/scripts/optional/paint-popup'

q.safeDefineElement(PaintPopup)
